"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CupolaCity = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var SelectSpace_1 = require("../../inputs/SelectSpace");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var CupolaCity = (function (_super) {
    __extends(CupolaCity, _super);
    function CupolaCity() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.CUPOLA_CITY,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING],
            cost: 16,
            productionBox: Units_1.Units.of({ energy: -1, megacredits: 3 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(9).max(); }),
            metadata: {
                cardNumber: '029',
                description: 'Oxygen must be 9% or less. Place a City tile. Decrease your Energy production 1 step and increase your M€ production 3 steps.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(1).br;
                        pb.plus().megacredits(3);
                    }).nbsp.nbsp.city();
                }),
            },
        }) || this;
    }
    CupolaCity.prototype.canPlay = function (player) {
        return _super.prototype.canPlay.call(this, player) &&
            player.getProduction(Resources_1.Resources.ENERGY) >= 1 &&
            player.game.board.getAvailableSpacesForCity(player).length > 0;
    };
    CupolaCity.prototype.play = function (player) {
        return new SelectSpace_1.SelectSpace('Select a space for city tile', player.game.board.getAvailableSpacesForCity(player), function (space) {
            player.game.addCityTile(player, space.id);
            player.addProduction(Resources_1.Resources.ENERGY, -1);
            player.addProduction(Resources_1.Resources.MEGACREDITS, 3);
            return undefined;
        });
    };
    return CupolaCity;
}(Card_1.Card));
exports.CupolaCity = CupolaCity;
//# sourceMappingURL=CupolaCity.js.map